import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type StartOpusAgentVoiceSessionMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type StartOpusAgentVoiceSessionMutation = { __typename?: 'Mutation', startOpusAgentVoiceSession: { __typename?: 'StartOpusAgentVoiceSessionResult', success: boolean, clientSecret?: string | null, sessionConfig?: { [key: string]: any } | null, maxDurationSeconds?: number | null, error?: { __typename?: 'Error', code: string, message?: string | null } | null, voiceSession?: { __typename?: 'OpusAgentVoiceSession', id: string, realtimeModel: string } | null } };

export type EndOpusAgentVoiceSessionMutationVariables = Types.Exact<{
  input: Types.EndOpusAgentVoiceSessionInput;
}>;


export type EndOpusAgentVoiceSessionMutation = { __typename?: 'Mutation', endOpusAgentVoiceSession: { __typename?: 'EndOpusAgentVoiceSessionResult', success: boolean } };


export const StartOpusAgentVoiceSessionDocument = gql`
    mutation StartOpusAgentVoiceSession {
  startOpusAgentVoiceSession {
    success
    error {
      code
      message
    }
    voiceSession {
      id
      realtimeModel
    }
    clientSecret
    sessionConfig
    maxDurationSeconds
  }
}
    `;
export type StartOpusAgentVoiceSessionMutationFn = Apollo.MutationFunction<StartOpusAgentVoiceSessionMutation, StartOpusAgentVoiceSessionMutationVariables>;

/**
 * __useStartOpusAgentVoiceSessionMutation__
 *
 * To run a mutation, you first call `useStartOpusAgentVoiceSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartOpusAgentVoiceSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startOpusAgentVoiceSessionMutation, { data, loading, error }] = useStartOpusAgentVoiceSessionMutation({
 *   variables: {
 *   },
 * });
 */
export function useStartOpusAgentVoiceSessionMutation(baseOptions?: Apollo.MutationHookOptions<StartOpusAgentVoiceSessionMutation, StartOpusAgentVoiceSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartOpusAgentVoiceSessionMutation, StartOpusAgentVoiceSessionMutationVariables>(StartOpusAgentVoiceSessionDocument, options);
      }
export type StartOpusAgentVoiceSessionMutationHookResult = ReturnType<typeof useStartOpusAgentVoiceSessionMutation>;
export type StartOpusAgentVoiceSessionMutationResult = Apollo.MutationResult<StartOpusAgentVoiceSessionMutation>;
export type StartOpusAgentVoiceSessionMutationOptions = Apollo.BaseMutationOptions<StartOpusAgentVoiceSessionMutation, StartOpusAgentVoiceSessionMutationVariables>;
export const EndOpusAgentVoiceSessionDocument = gql`
    mutation EndOpusAgentVoiceSession($input: EndOpusAgentVoiceSessionInput!) {
  endOpusAgentVoiceSession(input: $input) {
    success
  }
}
    `;
export type EndOpusAgentVoiceSessionMutationFn = Apollo.MutationFunction<EndOpusAgentVoiceSessionMutation, EndOpusAgentVoiceSessionMutationVariables>;

/**
 * __useEndOpusAgentVoiceSessionMutation__
 *
 * To run a mutation, you first call `useEndOpusAgentVoiceSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEndOpusAgentVoiceSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [endOpusAgentVoiceSessionMutation, { data, loading, error }] = useEndOpusAgentVoiceSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEndOpusAgentVoiceSessionMutation(baseOptions?: Apollo.MutationHookOptions<EndOpusAgentVoiceSessionMutation, EndOpusAgentVoiceSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EndOpusAgentVoiceSessionMutation, EndOpusAgentVoiceSessionMutationVariables>(EndOpusAgentVoiceSessionDocument, options);
      }
export type EndOpusAgentVoiceSessionMutationHookResult = ReturnType<typeof useEndOpusAgentVoiceSessionMutation>;
export type EndOpusAgentVoiceSessionMutationResult = Apollo.MutationResult<EndOpusAgentVoiceSessionMutation>;
export type EndOpusAgentVoiceSessionMutationOptions = Apollo.BaseMutationOptions<EndOpusAgentVoiceSessionMutation, EndOpusAgentVoiceSessionMutationVariables>;